import navContext from '@/context/nav.context';
import { useContext } from 'react';
import { createPortal } from 'react-dom';

export function HeaderPortal(props: React.PropsWithChildren<object>) {
	const context = useContext(navContext);

	if (!context.ref?.current) {
		return null;
	}

	return createPortal(props.children, context.ref.current);
}
